export enum ClassRating {
  POSITIVE = 1,
  NEUTRAL = 2,
  NEGATIVE = 3
}

export const availableRatingsForClasses = [
  {
    title: "Ngebosenin",
    value: ClassRating.NEGATIVE,
    key: "negative",
    imgGrayscale:
      "/assets/kelas-live/rate-classes/rating-negative-grayscale.svg",
    img: "/assets/kelas-live/rate-classes/rating-negative.svg"
  },
  {
    title: "Biasa aja",
    value: ClassRating.NEUTRAL,
    key: "neutral",
    imgGrayscale:
      "/assets/kelas-live/rate-classes/rating-neutral-grayscale.svg",
    img: "/assets/kelas-live/rate-classes/rating-neutral.svg"
  },
  {
    title: "Seru!",
    value: ClassRating.POSITIVE,
    key: "positive",
    imgGrayscale:
      "/assets/kelas-live/rate-classes/rating-positive-grayscale.svg",
    img: "/assets/kelas-live/rate-classes/rating-positive.svg"
  }
];

export const getRatingObjByValue = (
  rating: ClassRating | null
):
  | {
      title: string;
      value: ClassRating;
      key: string;
      imgGrayscale: string;
      img: string;
    }
  | undefined => {
  return availableRatingsForClasses.find(({ value }) => value === rating);
};
